import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * SSOログインのコールバックページコンポーネント
 * - Cognitoから返却された認可コード（code）をURLパラメータから取得し、
 *   バックエンド（/api/auth/callback）へ引き渡してトークン交換を行わせる
 * - 認可コードは一度しか使えないため、sessionStorageで使用済みcodeを記録し
 *   同一codeの二重送信を防止する（React StrictModeのeffect二重実行対策）
 */
const SsoLoginCallbackPage = () => {
  const location = useLocation();

  useEffect(() => {
    const ssoInit = async () => {
      // SSOログインの場合、URLParamからcode取得
      const params = new URLSearchParams(location.search);
      const code = params.get("code");

      if (!code) return;

      // すでに使ったcodeなら何もしない
      if (sessionStorage.getItem("used_code") === code) return;

      sessionStorage.setItem("used_code", code);

      window.location.href = `${process.env.REACT_APP_BASE_URL}auth/callback?code=${code}`;
    };
    ssoInit();
  }, [location.search]);

  return <div>SSOログイン処理中...</div>;
};

export default SsoLoginCallbackPage;
